import { type AxiosInstance } from "axios";
import {
  type TradePriceSearchAPIParams,
  type TradePriceDataItem,
} from "../types/tradePrice";

/**
 * 取引価格タイル取得APIのリクエストパラメータ
 */
export interface GetTradePriceTileParams {
  /** ズームレベル */
  z: number;
  /** タイルX座標 */
  x: number;
  /** タイルY座標 */
  y: number;
  /** 取得期間の開始（例: "20231"） */
  from: string;
  /** 取得期間の終了（例: "20251"） */
  to: string;
  /** 価格情報区分コード（01: 不動産取引価格情報、02: 成約価格情報）カンマ区切りで複数指定可能 */
  priceClassification?: string;
  /** 物件種別コード（01: 宅地、02: 宅地及び建物、07: 中古マンション等）カンマ区切りで複数指定可能。未指定の場合は全ての物件種別が対象 */
  landTypeCode?: string;
}

/**
 * 取引価格タイルデータ（MVT形式）を取得するAPI
 *
 * @param {AxiosInstance} apiClient - axios
 * @param {GetTradePriceTileParams} params - リクエストパラメータ
 * @returns {Promise<ArrayBuffer>}
 */
export const getTradePriceTileAPI = async (
  apiClient: AxiosInstance,
  params: GetTradePriceTileParams
): Promise<ArrayBuffer> => {
  const response = await apiClient.get<ArrayBuffer>("/map/trade-price-tile", {
    params,
    responseType: "arraybuffer",
  });

  return response.data;
};

export const searchTradePriceAPI = async (
  apiClient: AxiosInstance,
  params: TradePriceSearchAPIParams
): Promise<TradePriceDataItem[]> => {
  // 年（未設定の場合は前年をデフォルト値として使用）
  const year = params.year ?? new Date().getFullYear() - 1;

  const requestParams: Record<string, string | number> = {
    prefecture: params.prefecture,
    year,
  };

  // 価格情報区分（任意）
  if (params.priceClassifications && params.priceClassifications.length > 0) {
    requestParams.priceClassification = params.priceClassifications;
  }

  // 住所（任意）
  if (params.location) {
    requestParams.location = params.location;
  }

  const response = await apiClient.get<TradePriceDataItem[]>(
    "map/trade-price",
    { params: requestParams }
  );

  return response.data;
};
